<template>
    <button class="svg-button svg-button--search-modal search-modal-button" title="Open Search" type="button" @click.prevent="showModal()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513.47 513.47">
            <path d="M53.72 53.72C89.55 17.92 136.49 0 183.43 0s93.85 17.92 129.68 53.72c35.8 35.8 53.72 82.74 53.72 129.68s-17.91 93.88-53.72 129.69c-35.83 35.83-82.77 53.72-129.68 53.72s-93.88-17.89-129.71-53.72C17.92 277.28 0 230.34 0 183.4S17.92 89.52 53.72 53.72Zm303.84 246.81 144.11 144.11c15.73 15.76 15.73 41.27 0 57.01-15.76 15.76-41.27 15.76-57 0L300.56 357.56l57-57.03ZM183.43 40.31c-36.62 0-73.25 13.98-101.2 41.9-27.95 27.95-41.92 64.57-41.92 101.2s13.97 73.25 41.92 101.2c27.95 27.92 64.57 41.9 101.2 41.9s73.25-13.98 101.17-41.9c27.95-27.95 41.92-64.57 41.92-101.2s-13.97-73.25-41.92-101.2c-27.92-27.92-64.54-41.9-101.17-41.9Z"/>
        </svg>
    </button>
</template>
<script>
import SearchModal from './SearchModal';

export default {
    props: {
        searchUrl: {
            type: String,
            required: false,
            default: '/search'
        },
        initialItems: {
            type: Array,
            required: true,
        },
    },
    methods: {
        showModal() {
            this.$modal.show(SearchModal, {
                searchUrl: this.searchUrl,
                initialItems: this.initialItems,
                height: 'auto',
                adaptive: true,
                scrollable: true,
                width: 900
            });
        }
    }
}
</script>